import React from 'react';
import AdvancedJurisprudenceSearch from '../../components/jurisprudence/AdvancedJurisprudenceSearch';

const JurisprudencePage: React.FC = () => <AdvancedJurisprudenceSearch />;

export default JurisprudencePage;
